<template>
      <div id="overlay" v-if="param_alert_flg">
        <div id="message_area" style="height:35%;width:85%;max-width: 600px;background-color: white;">
          <div>
            <h3 class="kojin-title"><b style='color:red'>申込み、又は申込み取消が発生しています</b></h3>
          </div>
          対象の体験プログラム名をクリックしてください。
          <div style="width:85%; margin:auto; margin-top:3%;min-height: 0px;height: 70%">
            <table style="width:100%; border-collapse: collapse;border: #ccc solid 1px;">
              <thead>
                <tr>
                  <th class="type-col">体験プログラムID</th>
                  <th style="background-color: pink;width: 100%;">体験プログラム名</th>
                </tr>
              </thead>
            </table>

            <div style="overflow-x: hidden;overflow-y: auto;height: 60%;border: #ccc solid 1px;">
              <table style="width:100%; border-collapse: collapse;">
                <tbody>
                  <tr v-for="(result,i) in param_alert" v-bind:key="i" tabindex="0">
                    <td class="type-col">
                      {{ result.taiken_id }}
                    </td>
                    <td v-on:click="Pgm_Switch(result.taiken_id)" style="width: 80%;cursor:pointer;">
                          {{ result.name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>

</template>

<script setup>
/* eslint-disable */
import { ref } from 'vue'
/* メッセージを表示するモーダルウィンドウ */
import { useRouter, useRoute } from 'vue-router'

const router = useRouter();
const route = useRoute()

const cityname = route.params.shakyo
const facility = route.params.shisetsu

const props = defineProps(["param_alert" , "param_alert_flg"]);

let param_alert = ref(null);
let param_alert_flg = ref(false)

param_alert = ref(props.param_alert);
param_alert_flg = ref(props.param_alert_flg)

const emit = defineEmits(['call', 'alert_close']);

const Pgm_Switch = (t_id) =>{
    Pgm_switch_close() 
    // 複数ユーザーを切り替える
    // emit('call', { cmd:'switch_user', id:u_id, role:role });
    router.push("/"+cityname+"/"+facility+"/Shisetsu/rireki_search/"+t_id)
}

const Pgm_switch_close = () => {  //このウィンドウを閉じる
    param_alert_flg.value = false;
    emit('alert_close');
}

</script>
<style>
#overlay{
  /* 要素を重ねた時の順番 */
  z-index:1;

  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);

  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 種類列は要求通り display:none で非表示、ただしDOMには残す */
.type-col {
  display:none;
}

.t-block {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.highlight-row {
  background-color: #d6ffff; /* 条件一致時の色 */
}

</style>

